import { batch } from "react-redux";
import { AppThunk } from "@/redux/RootReducer";
import { expectedVolumeActions } from "../ExpectedVolumeRedux";
import { ExpectedVolumeCollectionItem } from "../../types";

export const expectedVolumeLoad =
  (expectedVolumeCollection: ExpectedVolumeCollectionItem[]): AppThunk =>
  async (dispatch) => {
    batch(() => {
      expectedVolumeCollection.forEach((c) => {
        dispatch(
          expectedVolumeActions.setRowsForRoutePair(
            c.routePairId,
            c.expectedVolumeTableRows
          )
        );
        dispatch(
          expectedVolumeActions.setRoutePairMetaFields(c.routePairId, {
            hasVolume: c.routePairHasVolume,
          })
        );
      });
    });
  };
